import React, { type ReactNode, useContext } from 'react';
import { type MapDispatchToProps, type MapStateToProps, connect } from 'react-redux';

import { getDefaultArt } from '../../../lib/ArtUtils';
import * as D from '../deps';

export interface IBackstagePlayableRowItemStateProps {
  thirdTextUrl?: string;
  sourceCardMenuItems?: $TSFixMe;
  isStation?: boolean;
  isPlaying?: boolean;
  isPaused?: boolean;
  isCollected?: boolean;
  isMobileWeb?: ReturnType<typeof D.isMobileWeb>;
}

export interface IBackstagePlayableRowItemDispatchProps {
  pauseTrack: typeof D.Actions.UseCases.pauseTrack;
  playResumeSource: typeof D.playResumeSource;
  startStation: typeof D.Actions.UseCases.startStation;
}

export interface IBackstagePlayableRowItemOwnProps {
  pandoraId: string;
  pandoraType?: string;
  playablePandoraId?: string;
  inCollectionAlbumId?: string;
  shareParentSource?: $TSFixMe;
  seedId?: string;
  itemUrl?: string;
  itemName?: string | ReactNode;
  playIndex?: number;
  imgUrl?: string;
  hasBorderTopBottom?: boolean;
  secondText?: string | ReactNode;
  thirdText?: string | ReactNode;
  rightColChild?: string | ReactNode;
  secondTextUrl?: string;
  dominantColor?: string;
  isRowSmall?: boolean;
  trackDuration?: string;
  isExplicit?: boolean;
  isClean?: boolean;
  isRadioOnly?: boolean;
  isUnavailable?: boolean;
  rowNumber?: number;
  isPlaceholder?: boolean;
  isAlbumRadioOnly?: boolean;
  // eslint-disable-next-line react-redux/no-unused-prop-types
  showAlbumName?: boolean;
  isWidthHalf?: boolean;
  // eslint-disable-next-line react-redux/no-unused-prop-types
  sourceCardAlbumId?: string;
}

export type IBackstagePlayableRowItemProps = IBackstagePlayableRowItemStateProps &
  IBackstagePlayableRowItemDispatchProps &
  IBackstagePlayableRowItemOwnProps;

export const BackstagePlayableRowItem: React.FC<IBackstagePlayableRowItemProps> = props => {
  const { isWidthHalf = false } = props;
  const { AUDIO_PLAY_TRACK, PAUSE } = D.Constants.AudioPlayer.AudioPlayerActions;
  const { integration } = useContext(D.AppContext);

  const additionalIntegrationContext = {
    currentIndex: props.playIndex,
  };

  const getIntegrationData = (...addContexts: $TSFixMe): $TSFixMe => {
    return integration.getActionData(additionalIntegrationContext, ...addContexts);
  };

  const componentEventFuncHandler = ({
    // @ts-expect-error TS(7031) FIXME: Binding element 'pandoraId' implicitly has an 'any... Remove this comment to see the full error message
    pandoraId,
    // @ts-expect-error TS(7031) FIXME: Binding element 'componentEventType' implicitly ha... Remove this comment to see the full error message
    componentEventType,
    // @ts-expect-error TS(7031) FIXME: Binding element 'destinationUrl' implicitly has an... Remove this comment to see the full error message
    destinationUrl,
    // @ts-expect-error TS(7031) FIXME: Binding element 'currentIndex' implicitly has an '... Remove this comment to see the full error message
    currentIndex,
  }): $TSFixMe => {
    return integration.action.clicked(
      getIntegrationData({
        pandoraId,
        componentEventType,
        destinationUrl,
        currentIndex,
      }),
    );
  };

  const playButtonOnclick = (e: $TSFixMe): void => {
    e.preventDefault();
    if (props.isStation && !props.isCollected) {
      // TODO: WEBCA-2936 investigate why we're only passing these props through
      // to START_STATION.
      props.startStation({
        componentName: 'MyStationsListItem',
        rerouteBasedOnTier: true,
        pandoraId: props.pandoraId,
        // @ts-expect-error
        pageUrl: props.itemUrl,
      });
    } else {
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ pandoraId: any; currentIndex: ... Remove this comment to see the full error message
      componentEventFuncHandler({
        pandoraId: props.pandoraId,
        currentIndex: props.playIndex,
        componentEventType: AUDIO_PLAY_TRACK,
      });

      const pandoraType =
        props.playablePandoraId &&
        D.Utils.SourceType.getPandoraTypeFromPandoraId(props.playablePandoraId);
      // TODO: WEBCA-2934 investigate why we're only passing these props through
      // to PLAY_RESUME_SOURCE.
      // @ts-expect-error
      props.playResumeSource({
        context: D.Constants.Ads.Rewards.ContextTypes.BACKSTAGE,
        id: props.playablePandoraId || props.pandoraId,
        index: pandoraType && props.playIndex,
        pageUrl: props.itemUrl,
        pandoraType: pandoraType || D.Constants.SourceTypes.PandoraTypes.SONG,
      });
    }
  };

  const pauseButtonOnclick = (): void => {
    if (props.pauseTrack) {
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ pandoraId: any; currentIndex: ... Remove this comment to see the full error message
      componentEventFuncHandler({
        pandoraId: props.pandoraId,
        currentIndex: props.playIndex,
        componentEventType: PAUSE,
      });
      props.pauseTrack();
    }
  };

  const onLinkClick = (e: $TSFixMe): void => {
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ pandoraId: any; currentIndex: ... Remove this comment to see the full error message
    componentEventFuncHandler({
      pandoraId: props.pandoraId,
      currentIndex: props.playIndex,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  return (
    <D.AppContextIntegrationData data={additionalIntegrationContext}>
      <D.RowItem
        isRowSmall={props.isRowSmall}
        imgUrl={props.imgUrl || getDefaultArt()}
        playButtonOnclick={playButtonOnclick}
        pauseButtonOnclick={pauseButtonOnclick}
        mainText={props.itemName}
        mainTextUrl={props.itemUrl}
        rowUrl={props.isMobileWeb && props.itemUrl}
        mainTextOnclick={props.itemUrl && !props.isMobileWeb && onLinkClick}
        qaMainText={D.QA.BATL}
        secondText={props.secondText}
        secondTextUrl={!props.isMobileWeb && props.secondTextUrl}
        secondTextOnclick={!props.isMobileWeb && props.secondTextUrl && onLinkClick}
        thirdText={props.thirdText}
        thirdTextUrl={!props.isMobileWeb && props.thirdTextUrl}
        onlyShowRightColPlay={props.isMobileWeb}
        isFullRowLink={props.isMobileWeb}
        rightColChild={
          props.pandoraType === D.PandoraTypes.SONG ? props.trackDuration : props.rightColChild
        }
        sourceCardMenuItems={props.sourceCardMenuItems}
        isPlaying={props.isPlaying}
        isPaused={props.isPaused}
        isCollected={props.isCollected}
        isExplicit={props.isExplicit}
        isClean={props.isClean}
        isUnavailable={props.isUnavailable}
        isRadioOnly={props.isRadioOnly}
        isDisabled={props.isRadioOnly || props.isUnavailable}
        rowNumber={props.rowNumber}
        qaRow={D.QA.BPI}
        // @ts-expect-error TS(2339) FIXME: Property 'BTLIP' does not exist on type 'Readonly<... Remove this comment to see the full error message
        qaLeftColButton={D.QA.BTLIP}
        hasBorderTopBottom={props.hasBorderTopBottom}
        isPlaceholder={props.isPlaceholder}
        dominantColor={props.dominantColor}
        shouldHideBadges={props.isAlbumRadioOnly}
        isWidthHalf={isWidthHalf}
        isWidthFull={!isWidthHalf}
      />
    </D.AppContextIntegrationData>
  );
};

export const mapStateToProps: MapStateToProps<
  IBackstagePlayableRowItemStateProps,
  IBackstagePlayableRowItemOwnProps,
  $TSFixMe
> = (state, ownProps) => {
  const props = {};
  const { pandoraId, pandoraType, playablePandoraId } = ownProps;
  // @ts-expect-error TS(2339) FIXME: Property 'isMobileWeb' does not exist on type '{}'... Remove this comment to see the full error message
  props.isMobileWeb = D.isMobileWeb(state);

  const isStation = pandoraType === D.PandoraTypes.STATION;
  // @ts-expect-error TS(2339) FIXME: Property 'isStation' does not exist on type '{}'.
  props.isStation = isStation;
  const stationId = isStation
    ? D.getInDomain('playback.utils.getStationIdFromStationFactoryId', null)(state, pandoraId) ||
      D.getInDomain('playback.utils.getStationIdFromSeedPandoraId', null)(state, pandoraId)
    : null;

  const isPlaylist = pandoraType === D.PandoraTypes.PLAYLIST;

  const isAudioPlaying = D.getInDomain('playback.utils.isAudioPlaying', false)(state);
  const isTrackPlayingCurrently = D.getInDomain('playback.utils.isTrackPlayingCurrently', false)(
    state,
    pandoraId,
  );
  const isSourcePlayingCurrently =
    D.getInDomain('playback.utils.isSourcePlayingCurrently', null)(
      state,
      stationId || playablePandoraId || pandoraId,
    ) || D.getInDomain('playback.utils.isSourcePlayingCurrently', null)(state, `ST:0:${stationId}`);
  const isPlayingCurrently =
    pandoraType === D.PandoraTypes.SONG
      ? isTrackPlayingCurrently && isSourcePlayingCurrently
      : isSourcePlayingCurrently;
  // @ts-expect-error TS(2339) FIXME: Property 'isPlaying' does not exist on type '{}'.
  props.isPlaying = isPlayingCurrently && isAudioPlaying;
  // @ts-expect-error TS(2339) FIXME: Property 'isPaused' does not exist on type '{}'.
  props.isPaused = isPlayingCurrently && !isAudioPlaying;
  // @ts-expect-error TS(2339) FIXME: Property 'isCollected' does not exist on type '{}'... Remove this comment to see the full error message
  props.isCollected = D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
    state,
    pandoraId,
    ownProps.inCollectionAlbumId,
  );

  const shareParentSource =
    ownProps.shareParentSource ||
    (isStation || isPlaylist
      ? {
          shareParentSourceId: ownProps.seedId || pandoraId,
          shareParentSourceType: pandoraType,
        }
      : null);

  // @ts-expect-error TS(2339) FIXME: Property 'sourceCardMenuItems' does not exist on t... Remove this comment to see the full error message
  props.sourceCardMenuItems = D.getSourceCardMenuItems({
    albumId: ownProps.inCollectionAlbumId,
    pandoraId,
    pandoraType,
    shareParentSource,
    state,
  });

  return props;
};

const mapDispatchToProps: MapDispatchToProps<
  IBackstagePlayableRowItemDispatchProps,
  IBackstagePlayableRowItemOwnProps
> = {
  pauseTrack: D.Actions.UseCases.pauseTrack,
  playResumeSource: D.playResumeSource,
  startStation: D.Actions.UseCases.startStation,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstagePlayableRowItem);
